import { ReactNode } from 'react';

import styles from './tenant-monitoring-item.module.scss';

type TenantMonitoringItemProps = {
  icon: React.ReactElement;
  label: string;
  count?: ReactNode;
};

const TenantMonitoringItem = ({ icon, label, count }: Readonly<TenantMonitoringItemProps>): React.JSX.Element => (
  <div className={styles.monitoringItem}>
    <div className={styles.title}>
      {icon}
      {label}
    </div>
    {count}
  </div>
);

export default TenantMonitoringItem;
